/**
 * Open the Settings panel from anywhere on the home page, optionally
 * scrolled to one control. Index listens for the event and passes the
 * focus on to SettingsPanel, which brings that row into view and briefly
 * highlights it. Used by the "Good to know" notes so each link lands on
 * the control it names (sign-in, purchases, feedback, analytics).
 */
export const SETTINGS_OPEN_EVENT = "coe-settings-open";

/** Matches a `data-tutorial="settings-<focus>"` row in SettingsPanel. */
export type SettingsFocus = "account" | "purchases" | "feedback" | "analytics";

export interface SettingsOpenDetail {
  focus?: SettingsFocus;
}

export function openSettings(focus?: SettingsFocus): void {
  window.dispatchEvent(new CustomEvent<SettingsOpenDetail>(SETTINGS_OPEN_EVENT, { detail: { focus } }));
}
